import { config } from '../../constants'
import { Locale } from '../locale'
import { SquidexAuth } from './auth'
import { Emitter } from '../emitter'

export interface ISquidexTextLabel {
  key: {
    iv: string
  }
  text: {
    fr: string
    en: string
  }
}
export class SquidexTextLabels {
  public items: any[] = []
  private static storageKey = 'bannerData'
  private _ee: Emitter | null = null

  constructor(emitter: Emitter) {
    this._ee = emitter
  }

  async initialize() {
    if (!(await this.getStoredKeysFromStorage(SquidexTextLabels.storageKey))) {
      await this.getTextLabels(SquidexTextLabels.storageKey)
      this._ee?.emit('lvc:squidex_labels_loaded')
    }
  }
  async getTextLabels(storageKey: string): Promise<any> {
    const accessToken = await new SquidexAuth().getToken()
    if (!accessToken) {
      throw new Error('Failed to get access token')
    }
    const dataResponse = await fetch(`${config.squidex.contentApi}/banner/`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    const resp = await dataResponse.json()
    if (resp) {
      if (resp.items && resp.items.length > 0) {
        const items = resp.items.map((item: { data?: ISquidexTextLabel }) => item?.data)
        if (items) {
          this.storeKeysWithExpiry(storageKey, items, 24 * 60 * 60) // 1 day expiration
        } else {
          throw new Error('Response did not return any items')
        }
      }
    } else {
      throw new Error('There was a problem with the response')
    }
  }
  storeKeysWithExpiry(storageKey: string, labels: ISquidexTextLabel[], ttlInSeconds: number) {
    const now = new Date()
    const item = {
      value: labels,
      expiry: now.getTime() + ttlInSeconds * 1000, // Convert seconds to milliseconds
    }
    localStorage.setItem(storageKey, JSON.stringify(item))
  }
  async getStoredKeysFromStorage(storageKey: string) {
    const storedData = localStorage.getItem(storageKey)
    if (!storedData) {
      return null
    } else {
      const now = new Date()
      const item = JSON.parse(storedData)

      if (now.getTime() > item.expiry) {
        // Item has expired, trigger refresh
        await this.getTextLabels(SquidexTextLabels.storageKey)
      } else {
        return item.value
      }
    }
  }
  public static getKey(textKey: string) {
    const lang = Locale.language
    const labels = sessionStorage.getItem(this.storageKey)
    if (labels && labels) {
      const parsedLabels: ISquidexTextLabel[] = JSON.parse(labels).value
      if (parsedLabels && parsedLabels.length > 0) {
        const foundKey = parsedLabels.find(label => label.key.iv === textKey)
        if (foundKey && (lang === 'fr' || lang === 'en')) {
          return foundKey.text[lang]
        } else {
          return ''
        }
      } else {
        return ''
      }
    } else {
      return ''
    }
  }
}
